import api from './api';

// Service pour les statistiques de stock
export const stockStatsService = {
  // Récupérer toutes les statistiques de stock
  getStats: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.productId) params.append('productId', filters.productId);
    if (filters.variantId) params.append('variantId', filters.variantId);
    return api.get(`/api/admin/stock-stats?${params.toString()}`);
  },
};

export default stockStatsService;
